import { render, staticRenderFns } from "./template_component_detail.vue?vue&type=template&id=0daff946&scoped=true&"
import script from "./template_component_detail.vue?vue&type=script&lang=js&"
export * from "./template_component_detail.vue?vue&type=script&lang=js&"
import style0 from "./template_component_detail.vue?vue&type=style&index=0&id=0daff946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daff946",
  null
  
)

export default component.exports